import { ErrorInfo } from "react";

const ErrorFallback = ({ error }: { error: Error; errorInfo: ErrorInfo | null }) => (
  <div role="alert" className={"space-y-3 p-3"}>
    <p>Something went wrong!</p>
    <pre className={"text-lg text-error-1"}>{error.message}</pre>
    {/* {errorInfo && <pre className={"text-error-2 text-sm"}>{errorInfo.componentStack}</pre>} */}
  </div>
);

export default ErrorFallback;
